(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xc-pdp-assurance"] && !Shopify.designMode) return;
  try {
    const mountMobileBuy = () => {
    const bars = document.querySelectorAll('[data-xc-mobile-buy]');
    bars.forEach((bar, index) => {
      if (index > 0) {
        bar.remove();
        return;
      }
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountMobileBuy, { once: true });
  } else {
    mountMobileBuy();
  }
  document.addEventListener('shopify:section:load', mountMobileBuy);
  } catch(e) { console.error(e); }
})();

})();
